import { render, staticRenderFns } from "./ActivityDetailsCustomerData.vue?vue&type=template&id=4ca15ffb&"
import script from "./ActivityDetailsCustomerData.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailsCustomerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports